import urljoin from 'url-join';

export const ENV = process.env.ENV
export const AGENT_WIDGET_URL = "http://localhost:5173"
export const SUPPORT_AGENT_API = "https://localhost:3010"
export const API_HGT_BASEPATH = process.env.API_HGT_BASEPATH
export const API_AUDITTRAIL_BASEPATH = process.env.API_AUDITTRAIL_BASEPATH
export const DATADOG_TOKEN = process.env.DATADOG_TOKEN
export const AUTH_DOMAIN = process.env.AUTH_DOMAIN
export const AUTH_CLIENTID = process.env.AUTH_CLIENTID
export const IDLETIMER_IDLESTATUS_AWAY = process.env.IDLETIMER_IDLESTATUS_AWAY
export const IDLETIMER_IDLESTATUS_INACTIVE = process.env.IDLETIMER_IDLESTATUS_INACTIVE
export const IDLETIMER_IDLESTATUS_EXPIRED = process.env.IDLETIMER_IDLESTATUS_EXPIRED
export const IDLETIMER_COUNTDOWN = process.env.IDLETIMER_COUNTDOWN
export const URL_SURVEYOR_SSO = process.env.URL_SURVEYOR_SSO
export const API_BIOVIZ = process.env.API_BIOVIZ
export const API_KITS_UI = process.env.API_KITS_UI
export const API_LIBRARY_EXPLORER_UI = process.env.API_LIBRARY_EXPLORER_UI
export const API_ACADEMY_UI = process.env.API_ACADEMY_UI
export const API_BASEPATH_PORTAL = process.env.API_BASEPATH_PORTAL
export const API_BASEPATH_PATHWAY = process.env.API_BASEPATH_PATHWAY
export const API_BASEPATH_DISCOVERY = process.env.API_BASEPATH_DISCOVERY
export const ENABLE_KITS_UI = process.env.ENABLE_KITS_UI === 'true';
export const ENABLE_LIBRARY_EXPLORER_UI = process.env.ENABLE_LIBRARY_EXPLORER_UI === 'true';
export const ENABLE_ASSISTANT_WIDGET = process.env.ENABLE_ASSISTANT_WIDGET === 'true';
export const ENABLE_AGENT_CONTROLS = process.env.ENABLE_AGENT_CONTROLS === 'true';
export const ENABLE_EULA_MODAL = process.env.ENABLE_EULA_MODAL !== 'false'; // Default to true, set to 'false' to disable
export const ENABLE_SECURITY_ALERT = process.env.ENABLE_SECURITY_ALERT === 'true'; // Default to false, set to 'true' to enable
export const AUTH_CALLBACKURL = `${window.origin}/callback`;

/**Hub Hosts */
export const HUBS_BASEPATH = API_BASEPATH_PORTAL.replace("api/v1", "hubs");

/** Audit Trail */
export const API_AUDITTRAIL_USER_ACTION = urljoin(`${API_AUDITTRAIL_BASEPATH}`, 'user/action');
export const API_AUDITTRAIL_USER = urljoin(`${API_AUDITTRAIL_BASEPATH}`, 'user');
export const API_AUDITTRAIL_PROJECT_VIEW = urljoin(`${API_AUDITTRAIL_BASEPATH}`, 'project/view');
export const API_AUDITTRAIL_PROJECT_DOWNLOAD = urljoin(`${API_AUDITTRAIL_BASEPATH}`, 'project/download');
export const API_AUDITTRAIL_PROJECT_PERMISSIONS = urljoin(`${API_AUDITTRAIL_BASEPATH}`, 'user/permission/project');

/**Console Log */
export const CONSOLELOG_REDUXACTIONS = false;
export const CONSOLELOG_IDLEACTIONS = false;

/** Authentication Configuration */
export const AUTH_CONTAINER = "auth0-login-container";
export const AUTH_DBCONNECTIONNAME = "Username-Password-Authentication";

/**Data Dog */
export const DATADOG_URL = "datadoghq.com";

/**Endpoints  */
export const API_ENDPOINT_GLOBAL_SEARCH = urljoin(API_BASEPATH_PORTAL,'search/simple/');
export const API_ENDPOINT_FILES = urljoin(API_BASEPATH_PORTAL,'files/project/');
export const API_ENDPOINT_FILES_DOWNLOAD = urljoin(API_BASEPATH_PORTAL,'files/download');
export const API_ENDPOINT_FILES_DOWNLOAD_ALL_BY_PROJECT = API_ENDPOINT_FILES_DOWNLOAD;
export const API_ENDPOINT_MANAGEDPROJECT = urljoin(API_BASEPATH_PORTAL,'admin/users/projects');
export const API_ENDPOINT_MANAGEDPROJECT_SEARCH = urljoin(API_BASEPATH_PORTAL,'search/simple/');
export const API_ENDPOINT_USERLOGIN = urljoin(API_BASEPATH_PORTAL,'users/current');
export const API_ENDPOINT_PROJECT = urljoin(API_BASEPATH_PORTAL,'projects');
export const API_ENDPOINT_PROJECT_BYPROJECTCODE = urljoin(API_BASEPATH_PORTAL,'projects/projectCode');

//export const API_BIOVIZ = "https://globalviz-dev.metabolon.com";
export const API_BIOVIZ_STATS = urljoin(`${API_BIOVIZ}`, 'stats');

// agent widget
export const API_ENDPOINT_AGENT_TOKEN = urljoin(API_BASEPATH_PORTAL, 'assistant/token/portal');

// discovery panels
export const API_ENDPOINT_SMART_PANELS = urljoin(API_BASEPATH_DISCOVERY, 'client', 'projects');
export const API_ENDPOINT_SMART_PANELS_ADMIN_PROJECTIDS = urljoin(API_BASEPATH_DISCOVERY, 'admin','projectids');
export const API_ENDPOINT_SMART_PANELS_ADMIN_SAMPLESETIDS = urljoin(API_BASEPATH_DISCOVERY, 'admin','samplesetids');
export const API_ENDPOINT_SMART_PANELS_SAMPLESETIDS = urljoin(API_BASEPATH_DISCOVERY, 'client','samplesetids');
export const API_ENDPOINT_SMART_PANELS_PROJECTIDS = urljoin(API_BASEPATH_DISCOVERY, 'client','projectids');
export const API_ENDPOINT_SMART_PANELS_CDT = urljoin(API_BASEPATH_DISCOVERY,'client','CDT','download');
export const API_ENDPOINT_SMART_PANELS_FILE = urljoin(API_BASEPATH_DISCOVERY,'client', 'files', 'download');
export const API_ENDPOINT_SMART_PANELS_HEATMAP = urljoin(API_BASEPATH_DISCOVERY,'client', 'heatmap', 'download');
export const API_ENDPOINT_SMART_PANELS_RESULTS = urljoin(API_BASEPATH_DISCOVERY,'client', 'Visualization', 'download');
export const API_ENDPOINT_SMART_PANELS_SAMPLESET = urljoin(API_BASEPATH_DISCOVERY,'client', 'SampleSet', 'download');

export const API_ENDPOINT_SAMPLESETDATA = urljoin(API_BASEPATH_PATHWAY,'samplesets');
export const API_ENDPOINT_PROJECTS_ISEMPTY = urljoin(API_BASEPATH_PORTAL,'projects/empty');

/** Pathway Map endpoints */
export const API_ENDPOINT_PATHWAY_PLANT = urljoin(API_BASEPATH_PATHWAY,'pathwaymaps/PLANT');
export const API_ENDPOINT_PATHWAY_ANIMAL = urljoin(API_BASEPATH_PATHWAY,'pathwaymaps/ANIMAL');

export const API_ENDPOINT_PATHWAY_PLANT_MAP = urljoin(API_BASEPATH_PATHWAY,'pathwaymaps/file/get/map-plant-v5.json');
export const API_ENDPOINT_PATHWAY_ANIMAL_MAP = urljoin(API_BASEPATH_PATHWAY,'pathwaymaps/file/get/map-animal-v5.json');

export const API_ENDPOINT_PATHWAY_PLANT_PUT_MAP = urljoin(API_BASEPATH_PATHWAY,'pathwaymaps/file/post');
export const API_ENDPOINT_PATHWAY_ANIMAL_PUT_MAP = urljoin(API_BASEPATH_PATHWAY,'pathwaymaps/file/post');

/**Admin Endpoints */
export const API_ENDPOINT_FILES_ADMIN = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'project');
export const API_ENDPOINT_FILES_ADMIN_DOWNLOAD = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'download');
export const API_ENDPOINT_PUBLISH_FILES = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'publish', 'collection');
export const API_ENDPOINT_PUBLISH_FILE = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'publish', 'single');
export const API_ENDPOINT_REMOVE_FILE = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'remove', 'single');
export const API_ENDPOINT_UPDATE_FILE_PROPERTIES = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'update', 'single');

export const API_ENDPOINT_SAMPLESETDATA_ADMIN = urljoin(API_BASEPATH_PORTAL,'admin/samplesets/project/');
export const API_ENDPOINT_SAMPLESETDATA_ADMIN_SAVE = urljoin(API_BASEPATH_PORTAL,'admin/samplesets/save/single');
export const API_ENDPOINT_SAMPLESETDATA_ADMIN_SAVE_ALL = urljoin(API_BASEPATH_PORTAL,'admin/samplesets/save/collection');
export const API_ENDPOINT_SAMPLESETDATA_ADMIN_PUBLISH_PROJECT = urljoin(API_BASEPATH_PORTAL,'admin/samplesets/publish/project');

export const API_ENDPOINT_PROJECT_ADMIN = urljoin(API_BASEPATH_PORTAL,'admin/projects/');

export const API_ENDPOINT_PROJECT_ADMIN_SAVE = urljoin(API_BASEPATH_PORTAL,'admin/projects/save');
export const API_ENDPOINT_PROJECT_ADMIN_PUBLISH = urljoin(API_BASEPATH_PORTAL,'admin/projects/publish/project');
export const API_ENDPOINT_PROJECT_PUBLISH_SUMMARY = urljoin(API_BASEPATH_PORTAL,'admin/projects/summary');
export const API_ENDPOINT_PROJECT_ADMIN_CREATE = urljoin(API_BASEPATH_PORTAL,'admin/projects/publish/convert');

export const API_ENDPOINT_PROJECT_USERS = urljoin(API_BASEPATH_PORTAL,'admin', 'users', 'project');

export const API_ENDPOINT_USERS = urljoin(API_BASEPATH_PORTAL,'users');
// Still valid - matches GET /api/v1/admin/users/roles
export const API_ENDPOINT_USERS_AVAILABLEROLES = urljoin(API_BASEPATH_PORTAL,'admin/users/roles');
export const API_ENDPOINT_USERS_DETAILS= urljoin(API_BASEPATH_PORTAL,'users/details/contains');
export const API_ENDPOINT_PUBLISHING_STATUS = urljoin(API_BASEPATH_PORTAL,'admin/projects/publish/status');
export const API_ENDPOINT_PROJECTS_UPDATE_STATUS = urljoin(API_BASEPATH_PORTAL,'admin/projects/update/status/');
export const API_ENDPOINT_STAKEHOLDERS_ADMIN = urljoin(API_BASEPATH_PORTAL,'admin/projects/stakeholders');

/**File Uploader Endpoints */
export const API_ATTACHMENT_UPLOAD = urljoin(API_BASEPATH_PORTAL,'admin', 'files', 'upload', 'single');

/**DemoEmail */
export const demoEmailAddress = "portaldemo@metabolon.com";
export const supportEmailAddress = "portalsupport@metabolon.com";
export const demoSubject = "Request for demo";
export const demoBody = "(Please provide the information below so we connect you with the appropriate demo.)%0D%0A%0D%0AFirst Name:%0D%0ALast Name:%0D%0AEmail:%0D%0ACompany:%0D%0AIndustry:%0D%0AAddress:%0D%0AZip Code:%0D%0ACity:%0D%0AState or Territory:%0D%0ACounty Code (2 digit):";
export const getADemoLink = "https://www.metabolon.com/get-started/";
export const webpackversion = "4.0";

/** Revenue Recognition */
export const API_ENDPOINT_RECOGNIZE_REVENUE = urljoin(API_BASEPATH_PORTAL,'projects/recognize-revenue');